import { Rule } from '../types';

export const ruleClearSpace: Rule = (_submission) => {
  // CCQ 3.8.3.3 : espace de manœuvre 1500×1500 mm haut/bas requis.
  // L'outil ne peut pas mesurer cet espace (info terrain non-saisie).
  // On émet un INFO pour le rappeler dans la doc PDF générée.
  return {
    ruleId: 'clear-space-top-bottom',
    severity: 'info',
    humanMessage: `Rappel : prévoir 1500×1500 mm d'espace libre au sommet et au bas de la rampe (CCQ 3.8.3.3).`,
  };
};
